export default function dynamicallySort(key, order = 'asc') {
  const prop = key.includes('.') ? key.split('.') : [key];

  return function sort(a, b) {
    let varA;
    let varB;

    if (a !== null && b !== null) {
      if (prop.length > 1) {
        let i = 0;
        let valueA = a;
        let valueB = b;
        while (i < prop.length) {
          valueA = valueA[prop[i]];
          valueB = valueB[prop[i]];
          i += 1;
        }
        varA = typeof valueA === 'string' ? valueA.toUpperCase() : valueA;
        varB = typeof valueB === 'string' ? valueB.toUpperCase() : valueB;
      } else {
        if (!Object.prototype.hasOwnProperty.call(a, prop) || !Object.prototype.hasOwnProperty.call(b, prop)) {
          return 0;
        }
        varA = typeof a[prop] === 'string' ? a[prop].toUpperCase() : a[prop];
        varB = typeof b[prop] === 'string' ? b[prop].toUpperCase() : b[prop];
      }

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === 'desc' ? comparison * -1 : comparison;
    }
    return 0;
  };
}
